// frontend/src/components/InfoModal.js
import React from 'react';
import './Modal.css'; // Reusing existing Modal.css for styling
import WarningIcon from '@mui/icons-material/Warning';

const InfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content info-modal-content">
        <h2>
          <WarningIcon />
          Hinweis & Nutzungsbedingungen
        </h2>
        <div className="info-modal-text">
          <p>
            <b>HINWEIS & NUTZUNGSBEDINGUNGEN:</b><br /><br />
            Dies ist eine Open Source Community Page, welche Google-Translate verwendet, um die Seite in der jeweiligen Landessprache darzustellen.
            Es gibt keinerlei Integration von Webseiten Analytics und zu keinem Zeitpunkt werden Daten weitergereicht.
            Die Webseite läuft auf einem virtuellen Server bei HETZNER in Deutschland.
            MIT EURER REGISTRIERUNG STIMMT IHR SOMIT ZU, DASS ICH DIE DATEN LOKAL AUF DEM SERVER ABSPEICHERE UND AUSSCHLIEßLICH ZUM ZWECK DER DARSTELLUNG NUTZE.
            ES WERDEN ZU KEINEM ZEITPUNKT EURE BENUTZERDATEN AN DRITTE WEITERGEGEBEN!
            <br /><br />
            <b>FEATURES:</b><br /><br />
            - Einfache Registrierung und nachdem Ihr die E-Mail mit den Validierungslink bekommen habt, anklicken und Euer Account ist aktiv<br />
            - <b> WICHTIG: nutzt ein einfaches Passwort und nicht welches Ihr für sensible Portale nutzt, es sind keine kritischen Daten hier abgelegt!</b><br/>
            - Nachdem Ihr eingeloggt seid, tragt über den Link "HIFI Setups" Eurer Setup ein und klickt auf SPEICHERN !<br />
            - Über die Funktion "Profil" könnt Ihr Euer Passwort ändern, oder wenn Ihr umgezogen seid Eurer Adresse abändern.
            Dadurch wird erneut die Geo-Daten justiert und Euer Setup korrekt an Eurer neuen Anschrift angezeigt<br />
            - Über die Funktion "Upload" könnt Ihr 2 Bilder im hochauflösenden Format bereitstellen, da ich 50MB für beide Bilder erlaube!<br />
            - <b>WICHTIG: Wenn Ihr Eure Handykamera nutzt, entfernt Eure Metadaten vor dem Upload, da Bilder öffentlich zugänglich sind. Hierzu gibts es genügend Anleitungen!</b>
          </p>
        </div>
        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-btn">Schließen</button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;